import get from 'lodash/get';
import {DEFAULT_PICTURE_URL} from '@/constants';
import { STATUS_CODES } from '@/constants';


export default {
  name: 'import-tab',
  components: {},
  data() {
    return {
      acceptedFileType: ['application/json', ''],
      pictureImageUrl: '',
      text: 'text',
      importObjects: {},
      importCandidates: {},
      hasSelections: false,
      selections: [],
      uploadedFiles: [],
      parentKeys: new Set(),
      isDragging: false,
      override: false,
    };
  },
  mounted() {
    this.pictureImageUrl = get(this.record, 'picture.payload.url');
    if (this.pictureImageUrl === DEFAULT_PICTURE_URL) {
      this.record.picture.payload.url = '';
    }
  },
  computed: {
    selectedCount() {
      return Object.values(this.selections).filter(Boolean).length;
    },
    totalCount() {
      return Object.values(this.importObjects).reduce((sum, items) => sum + items.length, 0);
    },
  },
  methods: {
    selectAll() {
      const updated = {};
      Object.entries(this.importObjects).forEach(([category, items]) => {
        items.forEach(item => { updated[`${category}:${item.name}`] = true });
      });
      this.selections = updated;
    },
    deselectAll() {
      const updated = {};
      Object.entries(this.importObjects).forEach(([category, items]) => {
        items.forEach(item => { updated[`${category}:${item.name}`] = false });
      });
      this.selections = updated;
    },
    onSelectionChange(key, value) {
      this.selections = { ...this.selections, [key]: value };
    },
    toggleOverride(val) {
      this.override = val;
    },
    removeFile(fileName) {
      this.uploadedFiles = this.uploadedFiles.filter(file => file !== fileName);
      for (const [key, item] of Object.entries(this.importCandidates)) {
        if (item.fileName !== fileName) continue;
        delete this.importCandidates[key];
        delete this.selections[key];
      }
      for (const unit_type of Object.keys(this.importObjects)) {
        this.importObjects[unit_type] = this.importObjects[unit_type].filter(item => item.fileName !== fileName);
        if (this.importObjects[unit_type].length === 0) {
          delete this.importObjects[unit_type];
        }
      }
      this.selections = Object.fromEntries(
        Object.entries(this.selections).filter(([key]) => key in this.importCandidates),
      );
      const hasImportCandidates = Object.keys(this.importCandidates).length > 0;
      const hasImportObjects = Object.values(this.importObjects).some(items => items.length > 0);
      this.hasSelections = hasImportCandidates || hasImportObjects;
    },
    parseItems(jsonObj, fileName) {
      const parsedItems = [];
      if (!Array.isArray(jsonObj)) {
        jsonObj = [jsonObj];
      }
      for (const item of jsonObj) {
        const [unit_type, items] = Object.entries(item.items)[0];
        const internalItem = Object.values(items)[0];
        const parent = internalItem.name;
        const key = `${unit_type}:${parent}`;
        if (unit_type in this.importObjects) {
          this.importObjects[unit_type] = this.importObjects[unit_type].filter(i => i.name !== parent);
          this.importObjects[unit_type].push({ name: parent, fileName: fileName});
        } else {
          this.importObjects[unit_type] = [{ name: parent, fileName: fileName}];
        }
        this.parentKeys.add(parent);
        parsedItems.push({ key: key, item: item });
      }
      return parsedItems;
    },
    onFileUpload(file) {
      const rawFile = file.raw;
      if (!rawFile || !this.acceptedFileType.includes(rawFile.type)) return;
      this.fileNotSelected = false;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const text = e.target.result;
          const parsed = JSON.parse(text);
          const parsedItems = this.parseItems(Array.isArray(parsed) ? parsed : [parsed], rawFile.name);
          this.uploadedFiles.push(rawFile.name);
          for (const parsedItem of parsedItems) {
            if (Object.prototype.hasOwnProperty.call(this.importCandidates, parsedItem.key)) {
              continue;
            }
            this.importCandidates[parsedItem.key] = {item: parsedItem.item, fileName: rawFile.name};
            this.selections = {...this.selections, [parsedItem.key]: true};
            this.hasSelections = true;
          }
          this.$aiq.notify.success(`Imported: ${rawFile.name}`);
        } catch (err) {
          this.$aiq.notify.error(`Failed to import file: ${rawFile.name}`);
        }
      };
      reader.onerror = () => {
        this.$aiq.notify.error(`Failed to read file: ${rawFile.name}`);
      };
      reader.readAsText(rawFile);
    },
    onFileDrop(e) {
      this.isDragging = false;
      const files = Array.from(e.dataTransfer.files);
      for (const file of files) {
        if (!this.acceptedFileType.includes(file.type)) {
          this.fileNotSelected = true;
          return;
        }
        this.onFileUpload({ raw: file });
      }
    },
    async onImport() {
      const responses = {};
      for (const [key, isSelected] of Object.entries(this.selections)) {
        if (!isSelected) continue;
        const candidate = this.importCandidates[key].item;
        try {
          const response = await this.$store.dispatch('migrates/import', { payload: candidate, override: this.override });
          if (response.status === STATUS_CODES.SUCCESS) {
            this.$aiq.notify.success(`Imported ${key}`);
            responses[key] = { response: response.data };
          } else {
            this.$aiq.notify.error(`Failed to import ${key} - ${response.data.message}`);
            responses[key] = { error: response.data.message };
          }
        } catch (err) {
          const message = err.response?.data?.message || err.message;
          this.$aiq.notify.error(`Failed to import ${key} - ${message}`);
          responses[key] = { error: message };
        }
      }
      return responses;
    },
  },
};
